import { createTheme } from "@material-ui/core/styles";
const theme = createTheme({
  typography: {
    h1: {
      fontFamily: "Roboto",
      fontSize: "96px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "144px",
      letterSpacing: "-1.5px",
      textAlign: "center",
    },
    h2: {
      fontFamily: "Roboto",
      fontSize: "60px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "90px",
      letterSpacing: "-0.5px",
      textAlign: "center",
    },
    h3: {
      fontFamily: "Roboto",
      fontSize: "48px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "72px",
      letterSpacing: "0px",
      textAlign: "center",
    },
    h4: {
      fontFamily: "Roboto",
      fontSize: "60px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "90px",
      letterSpacing: "-0.5px",
      textAlign: "center",
    },
    h5: {
      fontFamily: "Roboto",
      fontSize: "24px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "36px",
      letterSpacing: "0px",
      textAlign: "center",
    },
    h6: {
      fontFamily: "Roboto",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "30px",
      letterSpacing: "0.15px",
      textAlign: "center",
    },
    subtitle1: {
      fontFamily: "Roboto",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "24px",
      letterSpacing: "0.15px",
      textAlign: "center",
    },
    subtitle2: {
      fontFamily: "Roboto",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "21px",
      letterSpacing: "0.1px",
      textAlign: "center",
    },
    body1: {
      fontFamily: "Roboto",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "24px",
      letterSpacing: "0.5px",
      textAlign: "center",
    },
    body2: {
      fontFamily: "Roboto",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "21px",
      letterSpacing: "0.25px",
      textAlign: "center",
    },
    button: {
      fontFamily: "Roboto",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "16px",
      letterSpacing: "1.25px",
      textAlign: "center",
    },
    caption: {
      fontFamily: "Roboto",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "15px",
      letterSpacing: "0.4px",
      textAlign: "center",
    },
    overline: {
      fontFamily: "Roboto",
      fontSize: "10px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "12px",
      letterSpacing: "1.5px",
      textAlign: "center",
    },
  },
  palette: {
    primary: {
      light: "E7ECE0",
      main: "#9DEE36",
      dark: "#42670D",
    },
    secondary: {
      main: "#42670D",
      light: "#FFFFFF",
      dark: "#000000",
    },
    error: {
      main: "#d32f2f",
      light: "#ef5350",
      dark: "#c62828",
    },
    warning: {
      main: "#ED6C02",
      light: "#ff9800",
      dark: "#e65100",
    },
    success: {
      main: "#2e7d32",
      light: "#4caf50",
      dark: "#1b5e20",
    },
    info: {
      main: "#0288d1",
      light: "#03a9f4",
      dark: "#01579b",
    },
    background: "#E7ECE0",
  },
});
export default theme;
